import { IconButton } from '@mui/material';
import styled from 'styled-components';
import { dropShadow, getButtonBackground, getColor } from './SvgIconButton';
import { isMobile } from 'react-device-detect';

export const SliceImageButton = styled(IconButton)<{ $isMaximized?: boolean; $isActive: boolean }>`
  border: 0;
  cursor: pointer;

  opacity: ${({ $isActive }): string => ($isActive ? '1' : '0.8')};
  background: ${({ $isActive, $isMaximized, theme }): string =>
    $isActive ? getButtonBackground(theme, !!$isMaximized) : 'none'};
  &:hover {
    background: ${({ theme, $isMaximized }): string => getButtonBackground(theme, !!$isMaximized)};
    filter: none;
  }

  &.minimized {
    visibility: ${({ $isActive }): string => ($isActive || isMobile ? 'visible' : 'hidden')};
    margin: -3px 0;
    .image-viewport-wrapper:hover &,
    &:hover {
      visibility: visible;
    }
    &:hover svg {
      fill: ${({ theme }): string => theme.palette.primary.light};
    }
  }

  & svg {
    fill: ${({ $isActive, theme }): string => getColor(theme, $isActive, true)};
    filter: ${dropShadow};
  }
`;
